module.exports = __webpack_public_path__ + "img/login-bg-img.69521c21.png";